<main id="main-content" aria-label="Add User">
  <div class="py-16 mx-10 md:mx-20">
    <div role="tablist" aria-label="Add user method" class="flex items-end border-b border-gray-300">
      <button
        *ngFor="let tab of tabs; let i = index"
        #tabHeader
        type="button"
        role="tab"
        [attr.aria-selected]="selectedIndex === i"
        [attr.aria-controls]="'panel-' + i"
        [id]="'tab-' + i"
        [attr.tabindex]="selectedIndex === i ? 0 : -1"
        (click)="setSelected(i)"
        (keydown)="onHeaderKey($event, i)"
        class="px-6 py-3 text-sm font-semibold cursor-pointer transition duration-200 outline-none rounded-t-xl border-2 border-b-4"
        [class.bg-dark-purple]="selectedIndex === i"
        [class.text-white]="selectedIndex === i"
        [class.border-dark-purpleborder-dark-purple]="selectedIndex === i"
        [class.font-bold]="selectedIndex === i"
        [class.bg-white]="selectedIndex !== i"
        [class.text-dark-purple]="selectedIndex !== i"
        [class.border-gray-300]="selectedIndex !== i"
        [class.hover:bg-gray-100]="selectedIndex !== i"
        [class.focus:ring-2]="true"
        [class.focus:ring-dark-purple]="true"
      >
        {{ tab }}
      </button>

      <div class="flex-1 h-0.5 bg-gray-300 ml-2"></div>
    </div>

    <div
      id="panel-0"
      role="tabpanel"
      aria-labelledby="tab-0"
      [hidden]="selectedIndex !== 0"
    >
      <prism-user-form></prism-user-form>
    </div>

    <div
      id="panel-1"
      role="tabpanel"
      aria-labelledby="tab-1"
      [hidden]="selectedIndex !== 1"
    >
      <prism-user-upload></prism-user-upload>
    </div>
  </div>
</main>
